import { render } from "./CategoryEditPage.vue?vue&type=template&id=4125bc56"
import script from "./CategoryEditPage.vue?vue&type=script&lang=js"
export * from "./CategoryEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__